import { render, staticRenderFns } from "./FilterSetV2.vue?vue&type=template&id=0bbc2e58"
import script from "./FilterSetV2.vue?vue&type=script&lang=js"
export * from "./FilterSetV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports